import React, { useEffect, useLayoutEffect, useState } from "react";
import { Select, Button, Menu, Input, DatePicker, Tag, Dropdown, Table, Modal } from "antd";
import {
    AppstoreOutlined, LinkOutlined, SwitcherOutlined, WalletOutlined, SearchOutlined, FilterOutlined, SortDescendingOutlined, EyeOutlined, EditOutlined,
    LockOutlined, CloseOutlined, MoreOutlined, CheckCircleOutlined,
    EllipsisOutlined,
    CheckOutlined
} from "@ant-design/icons";
import { PaymentLinkProvider } from "../../../context/PaymentLinkContext";
import { useMutation, useQuery } from "react-query";
import { getBusinessAccount, deleteLinkPayment, suspendLinkPayment } from "../service/api";
import ModalCreateLink from "./modalCreateLink";
// import DetailLinkModal from "./detailsModal"
import { getPaymentLink } from "../service/api";
import dayjs from "dayjs";
import '../utils/index.css';
import toast from "react-hot-toast";
import { Row, Col } from "reactstrap";
import { render } from "@testing-library/react";
import HeaderPart from "../component/headerPart";
import MainPart from "../component/mainPart";

// Variable de session
const currentUser = JSON.parse(sessionStorage.getItem('authUser'));

const CollectLink = () => {

    document.title = `Lien de paiement | ${process.env.REACT_APP_NAME} - ${process.env.REACT_APP_DESCRIPTION}`;

    // Variables d'état
    const [businessAccount, setBussinessAccount] = useState([]);
    const [selectedBusisnessAccount, setSelectedBusinessAccount] = useState();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);
    const [paymentLinks, setPaymentLinks] = useState([]);
    const [statusFilter, setStatusFilter] = useState(true);
    const [selectedLink, setSelectedLink] = useState(null);
    const [action, setAction] = useState();
    const [filteredLinks, setFilteredLinks] = useState([]);


    const formatDateFromArray = (dateArray) => {
        if (!dateArray || dateArray.length < 3) return ""; // Vérifie si la date est valide
        const [year, month, day] = dateArray;
        return dayjs(`${year}-${month}-${day}`).format("YYYY-MM-DD"); // Ajoute +1 au mois car en JS, janvier = 0
    };



    const handleCancel = () => {
        setIsModalOpen(false);
    }

    const handleOk = () => {
        setIsDetailsModalOpen(false);
    }


    const handleCancelDetails = () => {
        setIsDetailsModalOpen(false);
    }



    return (
        <PaymentLinkProvider>
            <Row>
                <Col>
                    <div className="gap-4 w-100 page-container">
                        <HeaderPart action={setAction} paymentLinkModal={setIsModalOpen} changeBusinessAccount={setSelectedBusinessAccount} />
                        <MainPart businessAccountSelected={selectedBusisnessAccount} linksFiltered={filteredLinks} setLinksFiltered={setFilteredLinks} />

                        {/* Modal to create link */}
                        <Modal
                            open={isModalOpen}
                            onCancel={handleCancel}
                            footer={false}
                            /* wrapClassName="custom-modal-responsive" */
                            width={550}
                        >
                            <div className="container px-2 px-md-5 py-2">
                                <ModalCreateLink
                                    /* onLinkCreated={addNewPaymentLink} */
                                    closeModal={handleCancel}
                                    formattingDate={formatDateFromArray}
                                    selectedBusiness={selectedBusisnessAccount}
                                    action={action}
                                />
                            </div>
                        </Modal>

                        {/* <Modal open={isDetailsModalOpen} onCancel={handleCancelDetails} footer={false} wrapClassName="custom-modal-responsive">
                            <div className="px-2 px-md-5 py-2">
                                <DetailLinkModal linkSelected={selectedBusisnessAccount} modalDetail={isDetailsModalOpen} setModalDetail={handleCancelDetails} formattingDate={formatDateFromArray} />
                            </div>

                        </Modal> */}

                    </div>
                </Col>
            </Row>
        </PaymentLinkProvider>

    );
}

export default CollectLink;